module.exports = __webpack_public_path__ + "img/img-3-15.4345d36b.png";